import { ISignedDocumentTemplateResponse } from "@wingspanhq/signed-documents/dist/lib/interfaces";
import { serviceSignedDocuments } from "../serviceSignedDocuments";

export const getSignedDocumentTemplate = async (
  id: string
): Promise<ISignedDocumentTemplateResponse> => {
  const response = await serviceSignedDocuments.get(`/template/${id}`);
  return response.data;
};
